import axios from 'axios';
import BaseApi from './base';
import {
    GET_CALLING_LIST,
    SAVE_OPERATOR_ORDER_NOTE
} from '@/constants/api';

export default class extends BaseApi {
    static getCallingList() {
        return axios.get(GET_CALLING_LIST)
    }

    static saveOperatorOrderNote(data) {
        return axios.post(SAVE_OPERATOR_ORDER_NOTE, this.stringify(data))
    }
}